import React from 'react';

import { useServicesPricingsQuery } from '../../플랜/services/use-services-pricings-query';
import { 판매관리_플랫폼_액션_옵션_리스트 } from '../data';

/**
 * 서비스별 요금 가져오는 훅.
 */
export const useH_서비스별_요금_가져오기 = () => {
  const { data } = useServicesPricingsQuery();

  const 판매관리_요금 = React.useMemo(() => {
    return data?.servicePricings.find(v => v.code === 'SERVICE-PRICING_CODE_SALE-PLATFORM');
  }, [data?.servicePricings]);

  const AI_상품정보_자동추출_요금 = React.useMemo(() => {
    return data?.servicePricings.find(v => v.code === 'SERVICE-PRICING_CODE_AUTO-INPUT');
  }, [data?.servicePricings]);

  const AI_통합서비스_요금 = React.useMemo(() => {
    return data?.servicePricings.find(v => v.code === 'SERVICE-PRICING_CODE_AI-INTEGRATION');
  }, [data?.servicePricings]);

  const AI_상품설명_요금 = React.useMemo(() => {
    return data?.servicePricings.find(v => v.code === 'SERVICE-PRICING_CODE_AI-DESCRIPTION');
  }, [data?.servicePricings]);

  const 판매관리_플랫폼별_요금 = React.useMemo(() => {
    return {
      ...Object.fromEntries(
        판매관리_플랫폼_액션_옵션_리스트.map(option => [
          option.value,
          판매관리_요금?.pricingPerItemUsages.find(v => v.usageType === option.value)?.fee ?? 0,
        ]),
      ),
    };
  }, [판매관리_요금?.pricingPerItemUsages]);

  return {
    판매관리_요금,
    판매관리_플랫폼별_요금,
    AI_상품정보_자동추출_요금,
    AI_통합서비스_요금,
    AI_상품설명_요금,
    기본서버이용료: data?.monthlyPrice ?? 50000,
  };
};
